export const UPDATES = [
  // {
  //   date: '2025-06-26',
  //   id: '2025-06-26',
  //   title: '新增諮詢委員會、調整副主任、調整Footer懸空的問題',
  //   body: ''
  // },
  // {
  //   date: '2025-06-30',
  //   id: '2025-06-30',
  //   title: '<p>更新資訊</p><em>1. 隱藏相關研究及各組研究方向頁面。<br/>2. 更新副主任。<br/>3. 更新活動快訊。<i>',
  //   body: ''
  // },
  // {
  //   date: '2025-07-03',
  //   id: '2025-07-03',
  //   title: '<p>更新資訊</p><em>1. 活動快訊: 加強描述活動與本中心的連結以及增加活動照片。<br/>2. 移除組長名稱及聯絡信箱。<i>',
  //   body: ''
  // },
  // {
  //   date: '2025-07-07',
  //   id: '2025-07-07',
  //   title: '<p>更新資訊</p><em>1. 活動快訊: 調整活動簡介Layout。<br/>2. 新增陳儀及顏汝芳老師進金融業務組。<i>',
  //   body: ''
  // },
  // {
  //   date: '2025-07-08',
  //   id: '2025-07-08',
  //   title: '<p>更新資訊 <small>(只顯示在測試網站)</small></p><br/><em>1. 金融業務組:加入陳業寧教授 (邀請中)<br/>2. 金融法律組:加入邵慶平教授<i>',
  //   body: ''
  // },
];
